import { Box, BoxProps, Skeleton } from '@mui/material';
import React from 'react';

type FieldSkeletonSkeletonProps = { count?: number; sx?: BoxProps['sx'] };

function FieldSkeleton({ count = 5, sx }: FieldSkeletonSkeletonProps) {
  const NO_OF_ITEMS_ARRAY: number[] = [];

  for (let i = 1; i <= count; i++) {
    NO_OF_ITEMS_ARRAY.push(i);
  }
  return (
    <>
      {NO_OF_ITEMS_ARRAY.map((value) => (
        <Box
          display='flex'
          flexDirection='column'
          bgcolor={(theme) => theme.palette.bgGray.main}
          margin={2}
          padding={1}
          borderRadius='10px'
          height='4rem'
          key={value}
          sx={sx}
        >
          <Skeleton
            variant='text'
            sx={{
              fontSize: '1rem',
            }}
            width={'20%'}
          />
          <Skeleton
            variant='text'
            sx={{
              fontSize: '1.3rem',
              borderRadius: '10px',
              padding: 1,
            }}
            width='95%'
          />
        </Box>
      ))}
    </>
  );
}

export default FieldSkeleton;
